import { use } from 'react'
import { SamlSessionContext } from '@/components/saml-session/context'

export const useSamlSession = () => use(SamlSessionContext)
